<template>
  <div class="d-flex">
    <div :class="$style.placeIconColumn">
      <v-icon size="20">{{
        place.done ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'
      }}</v-icon>
      <div v-if="!isLast" :class="$style.placeLine"></div>
    </div>
    <div class="d-flex flex-column">
      <span>{{ place.place }}</span>
      <span v-if="place.fill_percent" class="caption grey--text text--darken-1"
        >Fyllnadsgrad: {{ place.fill_percent }}</span
      >
      <span v-if="place.eta" class="caption grey--text text--darken-1 pb-2"
        >{{ !place.fill_percent ? 'Beräknad: ' : ''
        }}{{ place.eta | formatTime }}</span
      >
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'

export default {
  name: 'PlaceItem',

  props: {
    place: Object,
    isLast: Boolean
  },

  filters: {
    formatTime(date) {
      return format(new Date(date), 'yyyy-MM-dd HH:mm')
    }
  }
}
</script>

<style module>
.placeIconColumn {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  min-height: 52px;
  width: 56px;
}

.placeLine {
  width: 2px;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
}
</style>
